var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.9486V10.1065H12V8.21176H15V5.36966H17V8.21176H20V10.1065H17V12.9486H15ZM9 10.1065H5C3.61667 10.1065 2.4375 9.64466 1.4625 8.72097C0.4875 7.79729 0 6.68018 0 5.36966C0 4.05913 0.4875 2.94202 1.4625 2.01834C2.4375 1.09465 3.61667 0.632812 5 0.632812H9V2.52755H5C4.16667 2.52755 3.45833 2.80387 2.875 3.3565C2.29167 3.90913 2 4.58018 2 5.36966C2 6.15913 2.29167 6.83018 2.875 7.38281C3.45833 7.93544 4.16667 8.21176 5 8.21176H9V10.1065ZM6 6.31702V4.42229H14V6.31702H6ZM20 5.36966H18C18 4.58018 17.7083 3.90913 17.125 3.3565C16.5417 2.80387 15.8333 2.52755 15 2.52755H11V0.632812H15C16.3833 0.632812 17.5625 1.09465 18.5375 2.01834C19.5125 2.94202 20 4.05913 20 5.36966Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachmentIcon.3e7922659f734546baaae0fdaae3bd07.svg";
export { ForwardRef as ReactComponent };